// Server tools that save objects to the user's map. The apps pick these up on their next
// sync; refreshing when the tool succeeds shows them straight away.
const OBJECT_CREATING_TOOLS = ['create_marker', 'create_shape']

export const isObjectCreatingTool = tool => OBJECT_CREATING_TOOLS.indexOf(tool) !== -1
